
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiOwnShipNoCommandAa as ObiOwnShipNoCommandAaElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-own-ship-no-command-aa.js';
 
 
 

 
 export const ObiOwnShipNoCommandAa = createComponent({
   react: React,
   tagName: 'obi-own-ship-no-command-aa',
   elementClass: ObiOwnShipNoCommandAaElement,
   events: {
     
   }
  });
 
 